import React, { useEffect, useState } from 'react'
import Footer from '../../components/Common/Footer'
import Header from '../../components/Header/Header'
import { useSearchParams } from 'react-router-dom'
import { auth, db, functions } from '../../firebase'
import { httpsCallable } from 'firebase/functions'
import { useAuthState } from 'react-firebase-hooks/auth'
import { useNavigate } from 'react-router-dom'
import { doc, updateDoc, collection, getDoc, addDoc, getDocs } from 'firebase/firestore'
import CloneModule from './clone.module.scss'
import LoadingGrid from '../../components/LoadingGrid/LoadingGrid'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import { Modal } from '@mui/material'
import { tempFolder } from '../../localConstant'
function Clone() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const ref = searchParams.get('ref')
  const uidFrom = searchParams.get('uidFrom')
  const canViewContent = searchParams.get('canViewContent')
  const [user] = useAuthState(auth)
  const [fromSchoolName, setFromSchoolName] = useState('')
  const [fromUserName, setFromUserName] = useState('')
  const [fromRole, setFromRole] = useState('')
  const [mode, setMode] = useState({})
  const [userData, setUserData] = useState({})
  const [promptsRef, setPromptsRef] = useState({})
  const [prompts, setPrompts] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [role, setRole] = useState('')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [folders, setFolders] = useState([])
  const [selectedFolderId, setSelectedFolderId] = useState('')
  const [isAuthorizedToCopyPrompt, setIsAuthorizedToCopyPrompt] = useState(true)

  useEffect(() => {
    const getUidFrom = async () => {
      const userDocRef = doc(db, 'users', uidFrom)
      setIsLoading(true)
      const userinfo = await getDoc(userDocRef)
      if (userinfo.data().role === 'tutor') {
        setFromRole('tutor')
        const getTutorInfo = httpsCallable(functions, 'get_tutor_info_of_mingaku')
        const getSchoolsInfo = httpsCallable(functions, 'get_schools_info')
        const getMingakuSchoolInfo = httpsCallable(functions, 'get_school_info_of_mingaku')
        const [tutorIndo, schoolInfo, mingakuSchoolInfo] = await Promise.all([
          getTutorInfo({ userId: userinfo.data().tutorDocId, schoolId: userinfo.data().schoolDocId }),
          getSchoolsInfo({ schoolIds: [userinfo.data().schoolDocId] }),
          getMingakuSchoolInfo({ schoolId: userinfo.data().schoolDocId })
        ])
        const { configData } = mingakuSchoolInfo.data
        if (configData) {
          const { isPromptCreationForbidden } = configData
          if (isPromptCreationForbidden) {
            setIsAuthorizedToCopyPrompt(false)
            alert('プロンプトを複製する権限がありません。')
            navigate('/')
          }
        }
        setFromSchoolName(schoolInfo.data.schoolInfo[0].data.name)
        setFromUserName(tutorIndo.data.tutorDocData.name ? tutorIndo.data.tutorDocData.name : '')
      } else {
        setFromRole('admin')
        const { mingakuUserId, email } = userinfo.data()
        const getAuth = httpsCallable(functions, 'get_admin_info_of_mingaku')
        const { data } = await getAuth({ userId: mingakuUserId })
        const { adminAuthData, adminDocData } = data
        setFromUserName(adminDocData.name ? adminDocData.name : '')
      }
      setIsLoading(false)
    }
    getUidFrom()
  }, [])

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      if (user) {
        const userDocRef = doc(db, 'users', user.uid)
        getDoc(userDocRef).then(async (userDocSnapshot) => {
          if (userDocSnapshot.exists()) {
            const userData = userDocSnapshot.data()
            setUserData(userData)
            let promptsCollectionRef
            if (!!userData.studentDocId) {
              // 生徒アカウントの場合
              navigate('/')
            } else if (userData.role === 'tutor') {
              setRole('tutor')
              // 先生アカウントの場合
              const mingakuDocRef = doc(db, 'externalServices', 'mingaku')
              promptsCollectionRef = collection(mingakuDocRef, 'schools', userData.schoolDocId, 'prompts')
              const categoriesCollectionRef = collection(
                db,
                'externalServices',
                'mingaku',
                'schools',
                userData.schoolDocId,
                'categories'
              )

              const [_folders, _prompts] = await Promise.all([
                getCategories(categoriesCollectionRef),
                getPrompts(promptsCollectionRef)
              ])

              // フォルダ無所属のモードがあればフォルダ「フォルダ1」オプションを先頭に追加
              if (_prompts.some((p) => !p.categoryUid)) _folders.unshift({ ...tempFolder })
              setFolders(_folders)
              setPrompts(_prompts)
            } else {
              setRole('admin')
              // 管理人アカウントの場合
              promptsCollectionRef = collection(db, 'service_type', 'gpt-teacher', 'prompts')
              const _prompts = await getPrompts(promptsCollectionRef)
              setPrompts(_prompts)
            }

            setPromptsRef(promptsCollectionRef)

            const docRef = doc(db, ref)
            getDoc(docRef)
              .then((docSnap) => {
                if (docSnap.exists()) {
                  setMode({ ...docSnap.data() })
                } else {
                  console.log('No such document!')
                }
              })
              .catch((error) => {
                console.error('Error getting document:', error)
              })
          } else {
          }
        })
      } else {
        alert('現在はログアウト状態となっていますので複製ができません。お使いのアカウントにログインしてください。')
      }
    })
  }, [])

  const startCloningProcess = async () => {
    if (isLoading) return
    if (role === 'tutor' && folders.length) {
      setIsModalOpen(true)
      return
    }
    if (role !== 'tutor' && role !== 'admin') return
    try {
      await clone()
      return
    } catch (e) {
      alert('モードの複製に失敗しました。')
      console.error(e)
    }
  }

  const handleClone = async () => {
    try {
      await clone()
      return
    } catch (e) {
      alert('モードの複製に失敗しました。')
      console.error(e)
    }
  }

  // ↓2つはほぼ同じ内容だが、何か条件を付けられるようにあえて別々の関数として定義
  const getPrompts = async (promptsCollectionRef) => {
    const promptSnapshot = await getDocs(promptsCollectionRef)
    if (promptSnapshot.empty) return []
    return promptSnapshot.docs.filter((doc) => doc.exists()).map((doc) => doc.data())
  }
  const getCategories = async (categoriesCollectionRef) => {
    const categoriesSnapshot = await getDocs(categoriesCollectionRef)
    if (categoriesSnapshot.empty) return []
    return categoriesSnapshot.docs.filter((doc) => doc.exists()).map((doc) => doc.data())
  }

  const clone = async () => {
    if (!isAuthorizedToCopyPrompt) return
    setIsLoading(true)

    if (prompts.length) {
      const existingTitles = prompts.map((p) => p.prompt_title ?? '').filter((_) => _)
      let newTitle = mode.prompt_title
      let count = 0
      while (existingTitles.includes(newTitle)) {
        count++
        newTitle = `${mode.prompt_title}(複製${count > 1 ? count : ''})`
      }
      mode.prompt_title = newTitle
    }

    const newDocRef = await addDoc(promptsRef, {
      ...mode,
      enable: false,
      updatedAt: new Date().getTime(),
      isDuplicated: true,
      canViewContent: canViewContent !== 'false',
      uidFrom,
      categoryUid: (() => {
        if (role === 'admin') return ''
        if (!selectedFolderId) return ''
        if (selectedFolderId === 'tempFolder') return ''
        return selectedFolderId
      })()
    })

    await updateDoc(newDocRef, { ref: newDocRef })
    setIsLoading(false)
    alert('複製に成功しました！')
    if (userData.role === 'tutor') {
      navigate(`/management?school_id=${userData.schoolDocId}&mode_id=${newDocRef.id}`)
    } else {
      navigate(`/management?mode_id=${newDocRef.id}`)
    }
  }

  const closeModal = () => {
    setSelectedFolderId('')
    setIsModalOpen(false)
  }

  return (
    <div>
      <Header />
      {isLoading ? <LoadingGrid /> : <></>}
      <div className={CloneModule.cloneMessage}>
        <div>
          <div>
            {fromRole === 'tutor' ? (
              <div className={CloneModule.message}>
                {fromSchoolName}が作成したモード「{mode.prompt_title}」を複製できます
              </div>
            ) : (
              <div className={CloneModule.message}>
                みんがく管理人が作成したモード「{mode.prompt_title}」を複製できます
              </div>
            )}
          </div>
          <div className={CloneModule.modeContainer}>
            <div className={CloneModule.mode}>
              <div className={CloneModule.title} style={{ background: mode.modeColor ?? '' }}>
                <h4 className={CloneModule.title}>{mode.prompt_title}</h4>
              </div>
              <div className={CloneModule.cardBottomContainer}>
                {mode.prompt_description && mode.prompt_description !== '' ? (
                  <div className={CloneModule.description}>{mode.prompt_description}</div>
                ) : (
                  <div className={CloneModule.description}>{''}</div>
                )}
                <div onClick={() => startCloningProcess()} className={CloneModule.start}>
                  複製する +
                </div>
              </div>
            </div>
          </div>
          <div>
            {fromRole === 'tutor' ? (
              <div className={CloneModule.subMessage}>
                ※ {fromSchoolName}の{fromUserName}さんから共有されました
              </div>
            ) : (
              <div className={CloneModule.subMessage}>※ みんがく管理人の{fromUserName}さんから共有されました</div>
            )}
          </div>
        </div>
      </div>
      <Footer />
      <Modal
        open={isModalOpen}
        onClose={closeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className={`${CloneModule['folder-selection-modal']}`}>
          <div className={`${CloneModule['folder-selection-modal-header']}`}>
            {`${mode.prompt_title}を複製するフォルダを選んでください。`}
          </div>
          <div className={`${CloneModule['folder-selection-modal-main']}`}>
            <div className={`${CloneModule['form-control']}`}>
              <FormControl sx={{ width: '80%' }}>
                <InputLabel id="demo-simple-select-label">フォルダ</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectedFolderId}
                  label="Age"
                  onChange={(e) => setSelectedFolderId(e.target.value)}
                >
                  {folders.map((folder) => (
                    <MenuItem key={folder.uid} value={folder.uid ?? ''}>
                      {folder.name ?? ''}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div>
          <div className={`${CloneModule['folder-selection-modal-footer']}`}>
            <div className={`${CloneModule['folder-selection-modal-footer-button-container']}`}>
              <button onClick={handleClone}>複製する</button>
              <button className={`${CloneModule['negative']}`} onClick={closeModal}>
                キャンセル
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}
export default Clone
